import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { persistQueryClient } from '@tanstack/query-persist-client-core';
import type { QueryClient } from '@tanstack/vue-query';

import { PERSISTED_QUERY_ROOTS } from './queryKeys';

const PERSIST_KEY = 'nakama-entity-query-cache';
const PERSIST_MAX_AGE_MS = 24 * 60 * 60 * 1000;

const localStorageAdapter = {
  getItem: (key: string) => Promise.resolve(window.localStorage.getItem(key)),
  setItem: (key: string, value: string) => {
    window.localStorage.setItem(key, value);
    return Promise.resolve();
  },
  removeItem: (key: string) => {
    window.localStorage.removeItem(key);
    return Promise.resolve();
  },
};

const dehydrateOptions = {
  shouldDehydrateQuery: (query: { queryKey: readonly unknown[] }) => {
    const root = query.queryKey[0];
    return typeof root === 'string' && PERSISTED_QUERY_ROOTS.has(root);
  },
};

export function setupQueryPersistence(queryClient: QueryClient): Promise<void> {
  const persister = createAsyncStoragePersister({
    storage: localStorageAdapter,
    key: PERSIST_KEY,
  });

  const [, restorePromise] = persistQueryClient({
    queryClient,
    persister,
    maxAge: PERSIST_MAX_AGE_MS,
    dehydrateOptions,
  });

  return restorePromise;
}
